module.exports = __webpack_public_path__ + "static/media/card-master-card.e8ba780a.svg";